import axios from 'axios';
class EnvironmentVariableApi<EnvironmentVariable> {
  // let baseUrl = 'https://localhost:5000';
  // constructor() {}

  public getEnvironmentVariables: (env: string) => Promise<EnvironmentVariable[]> = async (
    env: string
  ) => {
    var baseUrl: string | undefined = '/api';
    var currentUrl = window.location.href;

    if (currentUrl.indexOf('localhost') !== -1) {
      baseUrl = process.env.REACT_APP_API_URL;
    }

    var hostName = env.replace('.com', '');

    return (await axios.get(`${baseUrl}/EnvironmentVariable/${hostName}`)).data.output;
  };
}

export const environmentVariableAPI = new EnvironmentVariableApi();
